import {
  GET_LEADERS_ATTEMPT,
  GET_LEADERS_SUCCESS,
  GET_LEADERS_FAILURE,
} from "../constants";

import { LeadersInitialState } from "../../types/leaders";

const initialState: LeadersInitialState = {
  fetchingLeadersList: 0,
  errorMessage: "",
  success: true,
  leadersList: [],
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getLeaders
    case GET_LEADERS_ATTEMPT:
      return {
        ...state,
        fetchingLeadersList: state.fetchingLeadersList + 1,
        success: true,
        errorMessage: "",
      };
    case GET_LEADERS_SUCCESS:
      return {
        ...state,
        fetchingLeadersList: state.fetchingLeadersList - 1,
        success: true,
        errorMessage: "",
        leadersList: validData(action.payload.data),
      };
    case GET_LEADERS_FAILURE:
      return {
        ...state,
        fetchingLeadersList: state.fetchingLeadersList - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};

function validData (data: any[]) {
  return data.filter((element: any) => element.leaderId)
}
